<template>
	<div class="card-box">
		<van-card ref="customCardRef" :thumb="image" v-bind="$attrs" v-on="$listeners">
			<!-- 遍历子组件非作用域插槽，并对父组件暴露 -->
			<template v-for="name in Object.keys($slots)" v-slot:[name]>
				<slot :name="name" />
			</template>
			<!-- 遍历子组件作用域插槽，并对父组件暴露 -->
			<template v-for="name in Object.keys($scopedSlots)" v-slot:[name]="data">
				<slot :name="name" v-bind="data"></slot>
			</template>
		</van-card>
	</div>
</template>

<script>
import { getImageUrl, isHttp } from "@/utils/upload";

/**
 * 具体文档请查看vant的Card组件
 * @see https://vant-contrib.gitee.io/vant/v2/#/zh-CN/card
 */

export default {
	inheritAttrs: false,
	props: {
		/**封面 */
		thumb: {
			type: String,
			default: ""
		},
		/** 卡片header样式 - 主要用于控制flex-direction */
		headerStyle: {
			type: Object,
			default: () => ({})
		},
		/** 卡片封面样式 */
		thumbStyle: {
			type: Object,
			default: () => ({})
		},
		/** 卡片tag样式 */
		tagStyle: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			image: "" // 卡片图片URL
		};
	},

	async mounted() {
		this.image = await this.getCoverURL(this.thumb);
		this.addStyle();
	},

	methods: {
		/**获取图片 */
		async getCoverURL(productCover) {
			return await new Promise((resolve) => {
				if (productCover && !isHttp(productCover)) {
					getImageUrl(productCover, (url) => {
						resolve(url);
					});
				} else {
					resolve(productCover);
				}
			}).catch(() => {
				// console.error('获取图片出错')
			});
		},

		/**
		 * 添加props传入的样式
		 */
		addStyle() {
			this.$nextTick(() => {
				if (!this.$refs.customCardRef) return;
				// 卡片容器
				const header = this.$refs.customCardRef.querySelector(".van-card__header");
				// 卡片封面
				const thumb = this.$refs.customCardRef.querySelector(".van-card__thumb");
				// 卡片封面遮罩
				const cardTag = this.$refs.customCardRef.querySelector(".van-card__tag");
				// 封面遮罩的tag
				const tag = this.$refs.customCardRef.querySelector(".van-tag");

				const {
					left = thumb?.style.left,
					top = thumb?.style.top,
					right = thumb?.style.right,
					bottom = thumb?.style.bottom,
					width = thumb?.style.width,
					height = thumb?.style.height,
					...rest
				} = this.thumbStyle;

				// 添加容器样式
				header && Object.assign(header.style, this.headerStyle);
				// 添加封面样式
				thumb && Object.assign(thumb.style, { width, height, ...rest });
				// 添加遮罩样式
				cardTag &&
					Object.assign(cardTag.style, {
						top,
						left,
						right,
						bottom
					});
				// 添加tag样式
				tag && Object.assign(tag.style, rest);
			});
		}
	}
};
</script>

<style scoped>
.card-box /deep/.van-card {
	padding: 0;
	background-color: unset;
}

.card-box /deep/.van-card__header {
	gap: 8px;
}

.card-box /deep/.van-card__thumb {
	margin-right: unset;
	overflow: hidden;
	border-radius: 6px;
	width: 130px;
	height: 80px;
}

.card-box /deep/.van-card__thumb img {
	width: 100%;
	height: 100%;
	border-radius: unset;
}

.card-box /deep/.van-card__content {
	min-height: auto;
	margin: 3px 0;
}

.card-box /deep/.van-card__tag {
	top: 5px;
	left: 5px;
	border-radius: 16px;
	overflow: hidden;
	width: fit-content;
}

.card-box /deep/.van-tag {
	position: static;
	font-size: 9px;
	border-radius: 16px;
	backdrop-filter: blur(7px);
	padding: 3px 8px 3px;
	background-color: unset;
	line-height: unset;
	background-color: rgba(0, 0, 0, 0.4);
}
.card-box /deep/.van-tag::after {
	display: none;
}

.card-box /deep/.van-card__title {
	font-weight: 500;
	font-size: 15px;
	color: #1d2023;
	line-height: 22px;
	max-height: none;
}

.card-box /deep/.van-card__price {
	font-weight: normal;
}
</style>

